import { render, staticRenderFns } from "./Payment_Method.vue?vue&type=template&id=045b7423&"
import script from "./Payment_Method.vue?vue&type=script&lang=js&"
export * from "./Payment_Method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports